import React from "react";
import { Form } from "react-aria-components";

import { reverse } from "@reactivated";

import { trackNewsletterSignup } from "../../utils/analytics";
import { ButtonPrimary } from "../Clickables";
import { Checkbox, TextField, useFormSubmit } from "../Form";

import styles from "./Newsletter.module.scss";

interface Props {
    emailLabel: string;
    consentLabel: string | null;
    submitLabel: string;
    blockId: string | undefined;
    onSuccess: () => void;
}

export const NewsletterForm = ({
    emailLabel,
    consentLabel,
    submitLabel,
    blockId,
    onSuccess,
}: Props) => {
    const { isSubmitting, nonFieldError, fieldErrors, handleSubmit } =
        useFormSubmit(
            (data) =>
                fetch(reverse("newsletter-block-submit"), {
                    method: "POST",
                    body: data,
                    headers: [["Accept", "application/json"]],
                }),
            () => {
                onSuccess();
                trackNewsletterSignup(
                    blockId ? `block_${blockId}` : "block_unknown",
                );
            },
        );

    return (
        <Form
            onSubmit={(e) => {
                if (!blockId) {
                    e.preventDefault();
                    return;
                }
                void handleSubmit(e);
            }}
            validationErrors={fieldErrors}
            className={styles.form}
        >
            {nonFieldError && (
                <p role="alert" className={styles.error}>
                    {nonFieldError}
                </p>
            )}
            <fieldset disabled={isSubmitting} className={styles.fieldset}>
                {blockId && (
                    <input type="hidden" name="block_id" value={blockId} />
                )}
                <TextField
                    name="email"
                    label={emailLabel}
                    type="email"
                    isRequired
                    className={styles.input}
                />
                {consentLabel && (
                    <Checkbox
                        className={styles.checkbox}
                        name="email_registration"
                        value="1"
                    >
                        {consentLabel}
                    </Checkbox>
                )}
                <div className={styles.submitWrapper}>
                    <ButtonPrimary type="submit">{submitLabel}</ButtonPrimary>
                </div>
            </fieldset>
        </Form>
    );
};
